import { render, staticRenderFns } from "./AutoBatchRenewalHDB.vue?vue&type=template&id=2ffead82&"
import script from "./AutoBatchRenewalHDB.vue?vue&type=script&lang=js&"
export * from "./AutoBatchRenewalHDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports